import api from "../../utils/axiosInstance.js";
import { GET_TOP_MARKET_ERROR, GET_TOP_MARKET_LIST, GET_TOP_MARKET_LIST_REQUEST, UPDATE_TOP_MARKET_DATA, REMOVE_TOP_MARKET_DATA } from "../../ActionTypes/ActionTypes.js";

const getTopMarketRequest = () => ({ type: GET_TOP_MARKET_LIST_REQUEST });
const getTopMarketSuccess = (data) => ({ type: GET_TOP_MARKET_LIST, payload: data });
const getTopMarketError = (error) => ({ type: GET_TOP_MARKET_ERROR, payload: error });

export const getTopMarketTradePairList = (data) => async (dispatch) => {
    dispatch(getTopMarketRequest());
    try {
        const response = await api.post(`/pair/pair-tabs`, data);
        if (response.data.success) {
            dispatch(getTopMarketSuccess(response.data));
        } else {
            dispatch(getTopMarketError(response?.data?.message));
        }
    } catch (error) {
        dispatch(getTopMarketError(error.response?.data?.message || error.message));
    }
};

export const updateTopMarketTradePairData = (newData) => ({
    type: UPDATE_TOP_MARKET_DATA,
    payload: newData
});

export const removeTopMarketTradePairData = (newData) => ({
    type: REMOVE_TOP_MARKET_DATA,
    payload: newData
});